import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import BottomMenu from './BottomMenu';
  
class SubmitOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: true,
            orderSubmitted: 'N',
            orderID: ''
        };
    }

    fetchRestaurantMenu(mode,id,items,customer,address_id,anikZai,payMode,offer_id,offer_code) {
        var subsciber_id = localStorage.getItem('SUBSCRIBER_ID');
        var that = this;
        fetch('https://m.donedelivery.in/api/submitorder_api.php?mode='+mode+'&id='+id+'&items='+items+'&customer='+customer+'&address_id='+address_id+'&anikZai='+anikZai+'&rdpaymode='+payMode+'&subsciber_id='+subsciber_id+'&offer_id='+offer_id+'&offer_code='+offer_code,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let order_submitted = result.order_submitted;
            if(order_submitted=='' || order_submitted==undefined)
                order_submitted = '';

            if(order_submitted=='Y')
            {
                if(payMode=='1')
                {
                    localStorage.removeItem('cartCIRCLE');
                    localStorage.removeItem('cartData');
                    localStorage.removeItem('AnikZai');
                    localStorage.removeItem('OFFER_APPLIED');
                    localStorage.removeItem('cartVendorID');
                    localStorage.removeItem('cartVendorName');
                    localStorage.removeItem('cartVendorTypeID');                        }
            }

            that.setState({ orderSubmitted:order_submitted, orderID:result.order_id  });
        });
    }

    componentDidMount() {
        let customer = '';
        let address_id = '';
        let anikZai = '';
        let payMode = '';

        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        if(localStorage.getItem('addressID'))
            address_id = localStorage.getItem('addressID');
        if(localStorage.getItem('AnikZai'))
            anikZai = localStorage.getItem('AnikZai');
        
        if(localStorage.getItem('payMode'))
            payMode = localStorage.getItem('payMode');

        if(anikZai==undefined || anikZai=='undefined')
            anikZai = '';

        let circle_id = localStorage.getItem('delCIRCLE');
        let itemLIST = '';
        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);
        if(cart !== null && cart!=='{}')
        {
            Object.keys(cartData).forEach(function(key) {
                let itemCOUNT = cartData[key];
                let item = key+'~~**~~'+itemCOUNT;
                itemLIST += item+',';
            });
        }
        
        if(itemLIST!='')
        {
            itemLIST = itemLIST.substring(0, itemLIST.length-1);
                
            let OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
            if(OFFER_APPLIED==null) 
                OFFER_APPLIED = '';
                
            let offerID = '';
            let offerAPPLIED = '';
            if(OFFER_APPLIED!='')
            {
                let OFFER_APPLIED2 =  OFFER_APPLIED.split('~~**~~');
                offerID =  OFFER_APPLIED2[0];
                offerAPPLIED =  OFFER_APPLIED2[1];
            }
    
            this.fetchRestaurantMenu('SUBMIT_ORDER',circle_id,itemLIST,customer,address_id,anikZai,payMode,offerID,offerAPPLIED);
        }
    }
    
    render() { 

        //console.log(localStorage.getItem('delCity'));
        //console.log(localStorage.getItem('delArea'));
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        if(this.state.orderSubmitted=='Y')
        {
            let payMode = localStorage.getItem('payMode');
            if(payMode=== null || payMode ==='{}')
            {   
                localStorage.setItem('payMode', '1');
                let payMode = localStorage.getItem('payMode');
            }
            
            if(payMode=='2')
            {
                return (<Redirect to={`/pay/${this.state.orderID}`} />)
            }
            else
            {
                return (<Redirect to={`/ordertrack/${this.state.orderID}/Y`} />)
            }
        }
        else
        {
            let cartEMPTY = 'Y';
            let cart = localStorage.getItem('cartData');
            let cartData = JSON.parse(cart);
            if(cart !== null && cart!=='{}')
            {
                cartEMPTY = 'N';
            }

            if(cartEMPTY=='Y')
            {
                return (<Redirect to='/home' />)
            }
        }

        if(localStorage.getItem('delCIRCLE')==null)
        {
	        return (<Redirect to={'/map'}/>)
        }

        return (
            <div>
                {/*this.state.LOADING && <Loader />*/}
                <div id="appCapsule">
                    <div className="section pt-6" style={{textAlign: 'center'}}>
                        <div className="spinner-border text-danger" role="status"> </div>
                        <h4 className="size-19">Please Wait</h4>
                        <h4 className="size-19">We are processing your order, do not click back or reload. This process can take sometime</h4>
                    </div>
                </div>
            </div>
        );
    }
}
      
export default SubmitOrder;


// WEBPACK FOOTER //
// ./src/components/SubmitOrder.js